import { selectIsDocumentReadyToShow } from '@newStore/documentUI/documentUISelectors';
import type React from 'react';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import AsideBody from './AsideBody';
import AsideErrorBoundary from './AsideErrorBoundary';
import AsideHeader from './AsideHeader';

import './aside.scss';

const Aside: React.FC<Record<string, never>> = () => {
  const showAside = useTypedSelector((state) => state.documentUI.currentEditingNode !== null);

  const isAsideLoading = useTypedSelector((state) => !selectIsDocumentReadyToShow(state));

  if (!showAside) {
    return null;
  }

  return (
    <AsideErrorBoundary>
      <div
        className="modal ng-aside horizontal right fade in ng-scope ng-isolate-scope"
        style={{ zIndex: 1036, display: 'block' }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-lg modal-aside">
              <div className="modal-content hide-box-shadow">
                <div className="modal-header">{!isAsideLoading && <AsideHeader />}</div>

                <div className="modal-body aside-components">
                  {isAsideLoading && <div className="spinner-icon bigCenter" />}
                  {!isAsideLoading && <AsideBody />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop fade ng-scope in"
        data-bootstrap-modal-aria-hidden-count="1"
        aria-hidden="true"
        style={{ zIndex: 1035 }}
      />
    </AsideErrorBoundary>
  );
};

Aside.displayName = 'Aside';
export default Aside;
